import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { scheduledTasksAPI } from '~/api';
import { ScheduledTask } from '~/types';

const getAll = createAsyncThunk('scheduledTasks/getAll', async () => {
  return scheduledTasksAPI.getAll();
});

const remove = createAsyncThunk(
  'scheduledTasks/remove',
  async (taskId: string) => {
    await scheduledTasksAPI.remove(taskId);
    return taskId;
  },
);

export function addTasks(
  state: ScheduledTaskState,
  action: PayloadAction<ScheduledTask[]>,
): void {
  state.loading = false;

  const tasks = action.payload;
  for (const task of tasks) {
    if (!state.map[task.id]) {
      state.items.push(task.id);
    }
    state.map[task.id] = task;
  }
}

export function removeTask(
  state: ScheduledTaskState,
  action: PayloadAction<string>,
): void {
  const taskId = action.payload;
  if (state.map[taskId]) {
    delete state.map[taskId];
    state.items = state.items.filter((id) => id !== taskId);
  }
}

export type ScheduledTaskState = {
  loading: boolean;
  map: Record<string, ScheduledTask>;
  items: string[];
};

const initialState: ScheduledTaskState = {
  loading: false,
  map: {},
  items: [],
};

export const scheduledTaskSlice = createSlice({
  name: 'scheduledTasks',
  initialState,
  reducers: {
    addTasks,
    removeTask,
  },
  extraReducers(builder) {
    // getAll
    builder.addCase(getAll.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAll.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getAll.fulfilled, addTasks);

    // remove
    builder.addCase(remove.fulfilled, removeTask);
  },
});

export const {
  actions: scheduledTasksActions,
  reducer: scheduledTasksReducer,
  selectors: scheduledTasksSelector,
} = scheduledTaskSlice;

export const scheduledTasksThunks = {
  getAll,
  remove,
};
